export default __webpack_public_path__ + "static/media/img (3).4f8518e5.jpg";